import React from "react";
var __jsx = React.createElement;
import { DayCalendarBody } from "./day-calendar-body";
import { ModeToggle } from "./mode-toggle";
import { MonthGridBody } from "./month-grid-body";
/** Popover contents: optional day/month toggle over the matching calendar body. */
export function DateFieldBody(_ref) {
  var type = _ref.type,
    enableMonthRange = _ref.enableMonthRange,
    mode = _ref.mode,
    onModeChange = _ref.onModeChange,
    month = _ref.month,
    onMonthChange = _ref.onMonthChange,
    singleValue = _ref.singleValue,
    rangeValue = _ref.rangeValue,
    minDate = _ref.minDate,
    maxDate = _ref.maxDate,
    onSelectSingle = _ref.onSelectSingle,
    onSelectRange = _ref.onSelectRange,
    onRequestClose = _ref.onRequestClose,
    highlightToday = _ref.highlightToday,
    testId = _ref.testId;
  var showToggle = type === "range" && enableMonthRange;
  var showMonthGrid = showToggle && mode === "month";
  return /*#__PURE__*/React.createElement("div", null, showToggle && /*#__PURE__*/React.createElement(ModeToggle, {
    mode: mode,
    onChange: onModeChange,
    testId: testId
  }), showMonthGrid ? /*#__PURE__*/React.createElement(MonthGridBody, {
    rangeValue: rangeValue,
    initialYear: month.getFullYear(),
    minDate: minDate,
    maxDate: maxDate,
    onSelectRange: onSelectRange,
    onRequestClose: onRequestClose,
    testId: testId
  }) : /*#__PURE__*/React.createElement(DayCalendarBody, {
    type: type,
    month: month,
    onMonthChange: onMonthChange,
    singleValue: singleValue,
    rangeValue: rangeValue,
    minDate: minDate,
    maxDate: maxDate,
    onSelectSingle: onSelectSingle,
    onSelectRange: onSelectRange,
    onRequestClose: onRequestClose,
    highlightToday: highlightToday,
    testId: testId
  }));
}